export function isProviderCode(value) {
    return /^\d{0,8}$/.test(value || '');
}
